export default {"src":"/_next/static/media/webinar-1.f7568ed0.svg","height":96,"width":242,"blurWidth":0,"blurHeight":0};